import { useRef } from 'react';
import { Camera } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ImageCaptureProps {
  onCapture: (files: File[]) => void;
  disabled?: boolean;
  multiple?: boolean;
}

export function ImageCapture({
  onCapture,
  disabled = false,
  multiple = true,
}: ImageCaptureProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    if (files.length > 0) {
      onCapture(files);
    }
    // Reset input so same file can be selected again
    e.target.value = '';
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture="environment"
        multiple={multiple}
        className="hidden"
        onChange={handleChange}
        disabled={disabled}
      />
      <Button
        type="button"
        variant="outline"
        size="icon"
        onClick={() => inputRef.current?.click()}
        disabled={disabled}
      >
        <Camera className="h-4 w-4" />
      </Button>
    </>
  );
}
